import styles from "../floorplans.module.scss";

export default function CommunityCostGuide() {
  return (
    <div className={styles.communityCostGuide} id="community-cost-guide">
      <h3>Getting Started Made Simple</h3>
      <p>
        We've compiled a comprehensive list of potential costs you may
        encounter as a current or future resident. This allows you to easily
        view your initial and monthly expenses in addition to the base rent of
        your future home.
      </p>
      <div className={styles.costIframe}>
      <div style={{
        position: 'relative',
        width: '100%',
        height: 0,
        paddingTop: '129.4118%',
        paddingBottom: 0,
        boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)',
        marginTop: '1.6em',
        marginBottom: '0.9em',
        overflow: 'hidden',
        borderRadius: '8px',
        willChange: 'transform'
      }}>
        <iframe 
          loading="lazy" 
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            border: 'none',
            padding: 0,
            margin: 0
          }} 
          src="https://www.canva.com/design/DAGlkcKzv-U/LNg3qFIDzsM9JmJOSUjpWg/view?embed" 
          allowFullScreen="allowfullscreen" 
            allow="fullscreen"
          />
        </div>
      </div>
    </div>
  );
}
